import React, { Component } from 'react';
import { array } from 'prop-types';
import { Table, Input, Row, Col, Button, Modal, Tag, Select } from 'antd';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import API from '../../../api';
import { promiseLoader, refreshAll } from '../../common/promise-loader';
import { includesFilter } from '../../../utils/filters';

const { Option } = Select;

class PreSalesList extends Component {
  static propTypes = {
    preSales: array
  };

  state = {
    filter: '',
    status: 'all'
  };

  onDelete = (record) => (event) => {
    event.preventDefault();
    event.stopPropagation();
    Modal.confirm({
      title: '¿Estás seguro que deseas eliminar esta pre-venta?',
      content: 'Esta acción no se puede deshacer.',
      okText: 'Eliminar',
      cancelText: 'Cancelar',
      onOk: async () => {
        await API.staff.deletePreSale(record.id);
        refreshAll();
      }
    });
  };

  getStatusTag = (convertedAt) => {
    if (convertedAt) {
      return <Tag color="default">Convertida</Tag>;
    }

    return <Tag color="green">Disponible</Tag>;
  };

  tableColumns = () => [
    {
      title: 'ID',
      dataIndex: 'id'
    },
    {
      title: 'Dirección',
      dataIndex: ['address', 'fullAddress'],
      render: (text) => text || 'Sin dirección'
    },
    {
      title: 'Vendedor',
      key: 'seller',
      render: (_, { seller }) => {
        if (!seller) return 'Sin vendedor';
        const { firstName, lastName } = seller;
        return `${firstName} ${lastName}`;
      }
    },
    {
      title: 'Comprador',
      key: 'buyer',
      render: (_, { buyer }) => {
        if (!buyer) return 'Sin comprador';
        const { firstName, lastName } = buyer;
        return `${firstName} ${lastName}`;
      }
    },
    {
      title: 'Estado',
      dataIndex: 'convertedAt',
      render: (convertedAt) => this.getStatusTag(convertedAt)
    },
    {
      title: 'Acciones',
      key: 'actions',
      render: (_, record) => (
        <div className="d-flex">
          <Link to={`/staff/pre_sales/${record.id}/edit`} className="mr-2">
            <Button type="link" onClick={(event) => event.stopPropagation()}>Editar</Button>
          </Link>
          <Button type="link" danger onClick={this.onDelete(record)}>
            Eliminar
          </Button>
        </div>
      )
    }
  ];

  filterRecords = () => {
    const { preSales } = this.props;
    const { filter, status } = this.state;

    let records = preSales.map((preSale) => ({
      seller: null,
      buyer: null,
      address: {},
      ...preSale
    }));

    if (status === 'available') {
      records = records.filter(({ convertedAt }) => !convertedAt);
    } else if (status === 'converted') {
      records = records.filter(({ convertedAt }) => convertedAt);
    }

    if (filter) {
      records = records.filter(includesFilter(filter, [
        ({ seller }) => seller ? `${seller.firstName} ${seller.lastName}` : '',
        ({ buyer }) => buyer ? `${buyer.firstName} ${buyer.lastName}` : '',
        ({ address }) => address?.fullAddress || '',
        'description',
        'tags'
      ], true));
    }

    return records;
  };

  render () {
    const { filter, status } = this.state;
    const records = this.filterRecords();

    return (
      <div style={{ padding: '30px' }}>
        <Row gutter={16} justify="center" align="middle" style={{ paddingBottom: '30px' }}>
          <Col>
            <Input
              placeholder='Buscar pre-venta...'
              addonAfter={<SearchOutlined/>}
              value={filter}
              onChange={({ target: { value } }) => this.setState({ filter: value })}
              style={{ width: '300px' }}
            />
          </Col>
          <Col>
            <Select value={status} onChange={(value) => this.setState({ status: value })} style={{ width: '200px' }}>
              <Option value='all'>Todas</Option>
              <Option value='available'>Disponibles</Option>
              <Option value='converted'>Convertidas</Option>
            </Select>
          </Col>
          <Col>
            <Link to="/staff/pre_sales/create">
              <Button type="primary">
                <PlusOutlined className="mr-1"/>
                Crear pre-venta
              </Button>
            </Link>
          </Col>
        </Row>
        <Table
          locale={{ emptyText: 'Sin pre-ventas' }}
          dataSource={records}
          columns={this.tableColumns()}
          rowKey={(record) => record.id}
          pagination={{ position: ['bottomCenter'] }}
        />
      </div>
    );
  }
}

export default promiseLoader(
  () => API.staff.getPreSales(),
  'preSales'
)(PreSalesList);
